import { notification } from '@pankod/refine-antd'

export declare type NotificationPlacement = 'top' | 'topLeft' | 'topRight' | 'bottom' | 'bottomLeft' | 'bottomRight';

type ToastProps = {
  message: string;
  description: string;
  placement: NotificationPlacement;
};

export const openToast = (level: string, props: ToastProps) => {
  if (level === 'success') notification.success(props)
  else if (level === 'error') notification.error(props)
  else if (level === 'warn') notification.warn(props)
  else notification.info(props)
}
